import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen3() {
    const { t } = useLang('theProductV2.Screen5');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen3-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen3-V2"
            data-section-id={'rapid-mag-Screen3-V2'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon label={t('label')} title={t('title')} desc={t('desc')} />
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762138687849/screen3.png',
                        'https://websiteoss.ecoflow.com/upload/image/1762138410652/screen3.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547648669/Screen5-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547655293/Screen5-m.webp',
                    )}
                />
            </div>
        </section>
    );
}
